module.exports = __webpack_public_path__ + "img/slide.f051feb4.jpg";